/**
 * @copyright Copyright 2021 Epic Systems Corporation
 * @file Spinner component for widgets to use for consistent loading indicator
 * @module Epic.AppOrchard.Dashboard.WidgetSpinner
 */
import { Spinner, VisuallyHidden } from "@chakra-ui/react";
import React, { FC } from "react";

/** Spinner component for widgets to use for consistent loading indicator */
export const WidgetSpinner: FC = () => {
	return (
		<Spinner role="status" borderWidth="5px" display="block" m="5rem auto 3rem auto" w="5rem" h="5rem">
			<VisuallyHidden>Loading</VisuallyHidden>
		</Spinner>
	);
};
